import React, { useMemo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import DocumentItem from '@/components/item/DocumentItem';
import { usePdpDocuments } from '@/api/hooks/usePdpDocuments';
import { planDocumentMapper } from '@/utils/mapper/planDocument';
import LoadingState from '@/components/LoadingState';
import { IconSvg } from '@/components/Icon';
import { usePdpIntroduction } from '@/api/hooks/usePdpIntroduction';
export default function PDPDocuments() {
  const {
    data,
    isLoading
  } = usePdpDocuments();
  const {
    data: introductionData
  } = usePdpIntroduction();
  const texts = {
    fileTitle: 'مدارک و مستندات',
    linkTitle: 'لینک‌ها'
  };
  const files = useMemo(() => (data?.documents || []).map(document => {
    return {
      index: 0,
      title: planDocumentMapper[document.type],
      link: document.file.url
    };
  }), [data?.documents]);
  const guarantees = useMemo(() => (introductionData?.guarantees || []).filter(i => i.file).map(guarantee => {
    return {
      index: 0,
      title: planDocumentMapper[guarantee.type],
      link: guarantee.file.url
    };
  }), [introductionData?.guarantees]);
  const links = data?.farabourseLink ? [{
    index: 0,
    title: 'استعلام طرح در فرابورس',
    link: data.farabourseLink || ''
  }] : [];
  return isLoading ? <LoadingState data-sentry-element="LoadingState" data-sentry-component="PDPDocuments" data-sentry-source-file="PDPDocuments.tsx" /> : <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--spacing_m_nudge)'
  }} data-sentry-element="Box" data-sentry-component="PDPDocuments" data-sentry-source-file="PDPDocuments.tsx">
      <Box sx={{
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      gap: 'var(--spacing_m)'
    }} data-sentry-element="Box" data-sentry-source-file="PDPDocuments.tsx">
        {files.length > 0 && <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 'var(--spacing_xs)'
      }}>
            <IconSvg component='Documents' width='32' height='32' />
            <Typography variant='headlineStrong__Wallfund' color='text.text' component='h2' id='section-3'>
              {texts.fileTitle}
            </Typography>
          </Box>}
        <Grid spacing={{
        md: 'var(--spacing_m)'
      }} container data-sentry-element="Grid" data-sentry-source-file="PDPDocuments.tsx">
          {files.map((file, idx) => {
          return <Grid size={{
            md: 6,
            xs: 12
          }} key={'items_' + idx}>
                <DocumentItem title={file.title} link={file.link} lastItem={idx === files.length - 1} index={file.index} type='file' />
              </Grid>;
        })}
          {guarantees.map((guarantee, idx) => {
          return <Grid size={{
            md: 6,
            xs: 12
          }} key={'items_guarantee_' + idx}>
                <DocumentItem title={guarantee.title} link={guarantee.link} lastItem={idx === guarantees.length - 1} index={guarantee.index} type='file' />
              </Grid>;
        })}
        </Grid>
      </Box>
      <Box sx={{
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      gap: 'var(--spacing_m)'
    }} data-sentry-element="Box" data-sentry-source-file="PDPDocuments.tsx">
        {' '}
        {links.length > 0 && <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 'var(--spacing_xs)'
      }}>
            <IconSvg component='Link' width='32' height='32' />
            <Typography variant='headlineStrong__Wallfund' color='text.text' component='h2'>
              {texts.linkTitle}
            </Typography>
          </Box>}
        <Grid spacing={{
        md: 'var(--spacing_m)'
      }} container data-sentry-element="Grid" data-sentry-source-file="PDPDocuments.tsx">
          {links.map((link, idx) => {
          return <Grid size={{
            md: 6,
            xs: 12
          }} key={'links_' + idx}>
                <DocumentItem title={link.title} link={link.link} lastItem={idx === links.length - 1} index={link.index} type='link' />
              </Grid>;
        })}
        </Grid>
      </Box>
    </Box>;
}